import React from 'react'
import './index.css'

const Loader: React.FC<{ text?: string }> = ({ text }) => {
  return (
    <div className="container-loader">
      <div id="loader">
        <pichincha-spinner size={100} border={4} />
      </div>
      <pichincha-typography
        style={{ width: '100%', display: 'block' }}
        variant="h4"
        color="blue"
        class="titleCargandoLoader"
        align="center"
      >
        {text !== undefined ? text : 'Cargando...'}
      </pichincha-typography>
    </div>
  )
}

export default Loader
